// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  boardId: __t.u64().name("board_id"),
  tileIndex: __t.u32().name("tile_index"),
  rewardType: __t.string().name("reward_type"),
  rewardAmount: __t.i64().name("reward_amount"),
  wasFree: __t.bool().name("was_free"),
  pickedAt: __t.u64().name("picked_at"),
});
